export enum ReservationListActions {
	DELETE_SELECTED = 'DELETE_SELECTED',
	CANCEL_BOOKING = 'CANCEL_BOOKING',
	REPORTA_LAVORAZIONE = 'Riporta in lavorazione',
	APPROVA = 'Approva',
	APPROVAWHATCHLISTED = 'Approva whatch list',
	RIFIUTA = 'Rifiuta',
	CHECKIN = 'CHECK-IN',
	CHECKOUT = 'CHECK-OUT',
	CONFIRM = 'CONFIRM',
	DIFFERENT_GROUP = 'DIFFERENT_GROUP',
	NO_SHOW = 'NO SHOW',
	NO_AUTO = 'NO AUTO',
	CHANGE_VEHICLE_REQUEST = 'CHANGE_VEHICLE_REQUEST',
	REJECTED_CHANGE_VEHICLE_REQUEST = 'REJECTED_CHANGE_VEHICLE_REQUEST',
	CANCELLATION_REQUEST = 'CANCELLATION_REQUEST'
}

// c'è una macchina a stati per il flusso, ma è da completare
// ReservationModel.stateMachine
export enum ReservationListStatus {
	REQUESTED          = 'REQUESTED',						// In Richiesta
	WAITING_FINANCE    = 'WAITING_FINANCE',			// 
	REJECTED_FINANCE   = 'REJECTED_FINANCE',		// 
	AUTHORIZED_FINANCE = 'AUTHORIZED_FINANCE',	// 
	WORKING            = 'WORKING',							// In lavorazione
	AUTHORIZED         = 'AUTHORIZED',					// Autorizzata
	BOOKED             = 'BOOKED',							// 
	DELIVERED          = 'DELIVERED',						// Consegnata
	WAITING_APPROVAL   = 'WAITING_APPROVAL',		// Attesa di approvazione
	APPROVED           = 'APPROVED',						// Approvata
	DELETED            = 'DELETED',							// Cancellata
	NO_VEHICLE         = 'NO_VEHICLE',					// La prenotazione non ha il veicolo (?)
	NO_SHOW            = 'NO_SHOW',							// 
	CLOSED             = 'CLOSED',							// Chiusa
	WRECK              = 'WRECK',								// 
	THEFT              = 'THEFT',								// Auto rubata (?) 
	CHANGE_VEHICLE 		 = 'CHANGE_VEHICLE',			// Cambio veicolo se rubato/danneggiato
	CLOSED_TO_BE_ARCHIVED 		 = 'CLOSED_TO_BE_ARCHIVED',			// Chiuso da archiviare
	NO_SHOW_TO_BE_ARCHIVED 		 = 'NO_SHOW_TO_BE_ARCHIVED',			// No show da archiviare
	DELETED_TO_BE_ARCHIVED 		 = 'DELETED_TO_BE_ARCHIVED',			// Cancellato da archiviare
	REJECTED_FINANCE_TO_BE_ARCHIVED 		 = 'REJECTED_FINANCE_TO_BE_ARCHIVED',			// Rifiutata finance da archiviare

	/*
	 *  Lo stato è associato alle prenotazioni create da Mobility
   *  L’operatore short term Relief vada a richiedere effettivamente il veicolo sostitutivo effettuando la prenotazione
	 * 
	 *  su NEMO sono poi visualizzate nella pagina "Da richiedere"
	 *  il supervisor le completa e le trasforma in prenotazioni normali
	 *  che saranno presenti nella pagina "Richieste veicoli"
	 * 
	 * 	PS: non dev'essere incluso nei filtri di ricerca
	 */
	TO_REQUEST         = 'TO_REQUEST',					// Viene creata da mobility, è incompleta
}

// sembra inutile
export enum PreleaseExtraStatuses {
	CHANGE_VEHICLE = 'CHANGE_VEHICLE'
}
// sembrano inutili anche questi
export enum ClosedReservationStatuses {
	REJECTED_FINANCE = 'REJECTED_FINANCE',
	DELETED = 'DELETED',
	NO_SHOW = 'NO_SHOW',
	CLOSED = 'CLOSED',
	WRECK = 'WRECK',
	THEFT = 'THEFT'
}

export enum ReservationListRenter {
	POOL_FLEET = 'Pool Fleet',
	HERTZ = 'Hertz'
}


export enum ReservationAvailableVehicles {
	PROPOSE_VEHICLE = 'Proponi veicolo',
	BOOK_VEHICLE = 'Prenotare un veicolo'
}

export enum ReservationRAC {
	CHOOSE_RAC = 'Scegli RAC',
}

export enum RenterType {
	FP = 'FP',
	RAC = 'RAC',
	ALL = 'ALL'
}

export const RenterTypeMapping: Record<RenterType, string> = {
	[RenterType.FP]: 'POOL_FLEET',
	[RenterType.RAC]: 'RAC',
	[RenterType.ALL]: 'BOTH',
};

export enum ReservationType {
	CARBODY = 'CARBODY',
	MECHANIC = 'MECHANIC',
	TYRES = 'TYRES',
	THEFT = 'THEFT',
	ADMINISTRATIVE = 'ADMINISTRATIVE'
}

export const ReservationTypeMapping: Record<ReservationType, string> = {
	[ReservationType.CARBODY]: 'CARROZZERIA',
	[ReservationType.MECHANIC]: 'MECCANICO',
	[ReservationType.TYRES]: 'TYRES',
	[ReservationType.THEFT]: 'FURTO',
	[ReservationType.ADMINISTRATIVE]: 'AMMINISTRATIVO',
};

export enum ReservationListOperation {
	UPGRADE = 'UPGRADE',
	UNDER_MAINTENANCE_WITH_CAR = 'UNDER_MAINTENANCE_WITH_CAR',
	UNDER_MAINTENANCE_WITHOUT_CAR = 'UNDER_MAINTENANCE_WITHOUT_CAR',
}

export const ReservationListOprationMapping: Record<ReservationListOperation, string> = {
	[ReservationListOperation.UPGRADE]: 'Upgrade',
	[ReservationListOperation.UNDER_MAINTENANCE_WITH_CAR]: 'UNDER_MAINTENANCE_WITH_CAR',
	[ReservationListOperation.UNDER_MAINTENANCE_WITHOUT_CAR]: 'UNDER_MAINTENANCE_WITHOUT_CAR'
};

export enum ReservationListRenter {
	FP = 'FP',
	RAC = 'RAC',
	ALL = 'ALL'
}

export enum settingsDisticts {
	COD_AXUS = 'COD_AXUS'
}

export enum ReservationListBlockType {
	CARBODY = 'CARBODY',
	MECHANIC = 'MECHANIC',
	TYRES = 'TYRES',
	THEFT = 'THEFT',
	ADMINISTRATIVE = 'ADMINISTRATIVE'
}

export enum OperationType {
	UPGRADE = 'UPGRADE',
	UNDER_MAINTENANCE_WITH_CAR = 'UNDER_MAINTENANCE_WITH_CAR',
	UNDER_MAINTENANCE_WITHOUT_CAR = 'UNDER_MAINTENANCE_WITHOUT_CAR'
}

export enum GroupType {
	A = 'A',
	B = 'B',
	C = 'C',
	D = 'D',
	E = 'E',
	F = 'F',
	J = 'J',
	M = 'M',
	S = 'S',
	T = 'T',
	U = 'U',
	V = 'V',
	Z = 'Z',
}

export const GroupTypeMapping: Record<GroupType, string> = {
	[GroupType.A]: 'A',
	[GroupType.B]: 'B',
	[GroupType.C]: 'C',
	[GroupType.D]: 'D',
	[GroupType.E]: 'E',
	[GroupType.F]: 'F',
	[GroupType.J]: 'J',
	[GroupType.M]: 'M',
	[GroupType.S]: 'S',
	[GroupType.T]: 'T',
	[GroupType.U]: 'U',
	[GroupType.V]: 'V',
	[GroupType.Z]: 'Z',
};

export enum PickUpNear {
	REPAIR_CENTER = 'REPAIR_CENTER',
	AIRPORT_DELIVERY_ADDRESS = 'AIRPORT_DELIVERY_ADDRESS'
}

export const PickUpNearMapping: Record<PickUpNear, string> = {
	[PickUpNear.REPAIR_CENTER]: 'REPAIR_CENTER',
	[PickUpNear.AIRPORT_DELIVERY_ADDRESS]: 'AIRPORT_DELIVERY_ADDRESS'
};

export enum MODULE_KEY_LIST {
	DELIVERY_SUPER_ADMIN = 'delivery_super_admin',
	INVOICING_SUPER_ADMIN = 'invoicing_super_admin',
	INVOICING_ASSISTANCE_CENTER = 'invoicing_assistance_center',
	CHANGE_USER_SUPER_ADMIN = 'change_user_super_admin',
	AUTHORITY_DEALER = 'authority_dealer',
	TYRES_ADMIN = 'tyres_admin',
	TYRES_CUSTOMER_SERVICE = 'tyres_customer_service',
	CLAIMS_SUPER_ADMIN = 'claims_super_admin',
	TYRES_POOL_FLEET = 'tyres_pool_fleet',
	AUTHORITY_ASSISTANCE_CENTER = 'authority_assistance_center',
	AUTHORITY_DEALER_TEST = 'authority_dealer_test',
	AUTHORITY_ASSISTANCE_CENTER_TEST = 'authority_assistance_center_test',
	AUTHORITY_SUPER_ADMIN = 'authority_super_admin',
	DELIVERY_ASSISTANCE_CENTER = 'delivery_assistance_center',
	CHANGE_USER_ASSISTANCE_CENTER = 'change_user_assistance_center',
	CONTRACT_CLOSING_ASSISTANCE_CENTER = 'contract_closing_assistance_center',
	TYRES_ASSISTANCE_CENTER = 'tyres_assistance_center',
	AUTHORITY_READER = 'authority_reader',
	CONTRACT_CLOSING_SUPER_ADMIN = 'contract_closing_super_admin',
}

export enum HistoryReservationListStatus {
	REJECTED_FINANCE = 'REJECTED_FINANCE',
	DELETED = 'DELETED',
	NO_SHOW = 'NO_SHOW',
	CLOSED = 'CLOSED',
	WRECK = 'WRECK',
	THEFT = 'THEFT'
}

export const HistoryReservationListStatusMapping: Record<HistoryReservationListStatus, string> = {
	[HistoryReservationListStatus.REJECTED_FINANCE]: 'REJECTED_FINANCE',
	[HistoryReservationListStatus.DELETED]: 'DELETED',
	[HistoryReservationListStatus.NO_SHOW]: 'NO_SHOW',
	[HistoryReservationListStatus.CLOSED]: 'CLOSED',
	[HistoryReservationListStatus.WRECK]: 'WRECK',
	[HistoryReservationListStatus.THEFT]: 'THEFT'
};

export enum AnagraficheListActions {
	VIP = 'VIP',
	FURTO = 'FURTO',
	ADD_THEFT = 'ADD_THEFT'
}

export enum BookingsProfileKey {
	module_relief_bookings_team = 'module_relief_bookings_team',
	module_relief_assistance_center = 'module_relief_assistance_center',
	module_relief_rac_center = 'module_relief_rac_center',
	module_relief_customer_service = 'module_relief_customer_service',
	module_relief_customer_service_supervisor = 'module_relief_customer_service_supervisor',
	module_relief_sales = 'module_relief_sales',
	module_relief_bookings_team_supervisor = 'module_relief_bookings_team_supervisor',
	module_relief_customer_finance = 'module_relief_customer_finance',
	module_prelease_bookings_team = 'module_prelease_bookings_team',
	module_prelease_assistance_center = 'module_prelease_assistance_center',
	module_prelease_rac_center = 'module_prelease_rac_center',
	module_prelease_customer_service = 'module_prelease_customer_service',
	module_prelease_customer_service_supervisor = 'module_prelease_customer_service_supervisor',
	module_prelease_sales = 'module_prelease_sales',
	module_prelease_bookings_team_supervisor = 'module_prelease_bookings_team_supervisor',
	module_prelease_customer_finance = 'module_prelease_customer_finance',
	module_relief_assistance_center_pilot = 'module_relief_assistance_center_pilot',
	
	// Profili fake - li ho mappati perché sennò l'app andava in loop infinito
	// Andrebbero eliminati da back-end
	prelease_bookings_team						= 'prelease_bookings_team',
	prelease_bookings_team_supervisor	= 'prelease_bookings_team_supervisor',
	relief_bookings_team							= 'relief_bookings_team',
	relief_bookings_team_supervisor		= 'relief_bookings_team_supervisor',
}
export enum BookingsReliefProfileKey {
	module_relief_bookings_team = 'module_relief_bookings_team',
	module_relief_assistance_center = 'module_relief_assistance_center',
	module_relief_rac_center = 'module_relief_rac_center',
	module_relief_customer_service = 'module_relief_customer_service',
	module_relief_customer_service_supervisor = 'module_relief_customer_service_supervisor',
	module_relief_sales = 'module_relief_sales',
	module_relief_bookings_team_supervisor = 'module_relief_bookings_team_supervisor',
	module_relief_customer_finance = 'module_relief_customer_finance',
	relief_bookings_team_supervisor = 'relief_bookings_team_supervisor',
}

export enum BookingsPreleaseProfileKey {
	module_prelease_bookings_team = 'module_prelease_bookings_team',
	module_prelease_assistance_center = 'module_prelease_assistance_center',
	module_prelease_rac_center = 'module_prelease_rac_center',
	module_prelease_customer_service = 'module_prelease_customer_service',
	module_prelease_customer_service_supervisor = 'module_prelease_customer_service_supervisor',
	module_prelease_sales = 'module_prelease_sales',
	module_prelease_bookings_team_supervisor = 'module_prelease_bookings_team_supervisor',
	module_prelease_customer_finance = 'module_prelease_customer_finance'
}

export enum BookingsReferenceTypeNote{
	BOOKING_PRELEASE = "BOOKING_PRELEASE",
	BOOKING_RELIEF = "BOOKING_RELIEF"
}

export enum InnerMessageBookingsMessageCode{
	BOOKINGS_SUCCESS_GENERAL_NOTE_CREATED_RELIEF = "BOOKINGS_SUCCESS_GENERAL_NOTE_CREATED_RELIEF",
	BOOKINGS_SUCCESS_GENERAL_NOTE_CREATED_PRELEASE = "BOOKINGS_SUCCESS_GENERAL_NOTE_CREATED_PRELEASE"
}